import { useTranslations } from 'next-intl';

const YEAR = '2024-2026';
const COMPANY_NAME = process.env.COMPANY_NAME || 'Common Sense Software';
const COMPANY_URL = process.env.COMPANY_URL || 'https://www.cssinc.tech/';

const Legal = () => {
  const t = useTranslations('common');

  const companyLink = (
    <a
      href={COMPANY_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="hover:underline"
    >
      {COMPANY_NAME}
    </a>
  );

  const allRightsReserved = t('all-rights-reserved');

  return (
    <div className="text-sm text-muted-foreground sm:text-center">
      © {YEAR} {companyLink}. {allRightsReserved}
    </div>
  );
};

export default Legal;
